import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useFormikContext, FieldArray } from "formik";
import SectionHeading from "../common/SectionHeading";
import CloseIcon from "@mui/icons-material/Close";
import DynamicFieldGroup from "../common/DynamicFieldGroup";

const LOAN_TYPES = [
  "Flat",
  "House",
  "Business",
  "Transport",
  "Personal",
  "Education",
  " Car / Bike",
];

const LibilityList = ({ formField }) => {
  const { libilityList } = formField;
  const { values, setFieldValue } = useFormikContext();
  //  console.log("form field values libility list", values);
  const isSmallDevice = useMediaQuery("(max-width:600px)");

  // Ensure at least one bank loan entry is present by default
  useEffect(() => {
    if (!values[libilityList.name] || values[libilityList.name].length === 0) {
      setFieldValue(libilityList.name, [{ type: "", amount: 0 }]);
    }
  }, [values, setFieldValue, libilityList.name]);

  // Console log the values for debugging

  return (
    <Box sx={{ p: isSmallDevice ? 0.5 : 1, maxWidth: 1000, mx: "auto" }}>
      <Paper
        elevation={3}
        sx={{
          p: isSmallDevice ? 2 : 3,
          position: "relative",
          border: "1px solid #e0e0e0",
          borderRadius: 3,
        }}
      >
        {/* <SectionHeading title="Liability List" number={5} /> */}

        {/* Bank Loans Section */}
        <FieldArray name={libilityList.name}>
          {({ push, remove }) => (
            <div className="mb-3">
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  mb: 2,
                  fontSize: { xs: "0.875rem", sm: "1rem" },
                }}
              >
                1. Bank Loans:
              </Typography>

              {values[libilityList.name]?.map((liability, index) => (
                <Box
                  key={index}
                  sx={{
                    mb: 3,
                    position: "relative",
                    p: { xs: 2, sm: 0 },
                    // mx: isSmallDevice ? -1 : 2,
                    borderRadius: 1,
                    border: "1px solid #e0e0e0",
                    // boxShadow: { xs: 2, sm: 0 },
                    // border: { xs: "1px solid #e0e0e0", sm: "none" },
                    backgroundColor: { xs: "#fff", sm: "transparent" },
                  }}
                >
                  {isSmallDevice && values[libilityList.name].length > 1 && (
                    <IconButton
                      size="small"
                      aria-label={`remove rental ${index}`}
                      onClick={() => remove(index)}
                      sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        backgroundColor: "rgba(0,0,0,0.04)",
                        zIndex: 5,
                      }}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                  <DynamicFieldGroup
                    showDropdown={true}
                    dropdownOptions={LOAN_TYPES}
                    dropdownValue={liability.type || ""}
                    onDropdownChange={(e) =>
                      setFieldValue(
                        `${libilityList.name}[${index}].type`,
                        e.target.value,
                      )
                    }
                    dropdownLabel="Loan Type"
                    showSlider={true}
                    sliderValue={liability.amount || 0}
                    onSliderChange={(e, newValue) => {
                      setFieldValue(
                        `${libilityList.name}[${index}].amount`,
                        newValue,
                      );
                    }}
                    sliderMin={0}
                    sliderMax={100000000}
                    sliderStep={10000}
                    showInputField={true}
                    inputValue={liability.amount || ""}
                    onInputChange={(e) => {
                      const newValue = Number(e.target.value) || 0;
                      setFieldValue(
                        `${libilityList.name}[${index}].amount`,
                        newValue,
                      );
                    }}
                    inputLabel="Amount ₹"
                    inputType="number"
                    showRemoveButton={
                      !isSmallDevice && values[libilityList.name].length > 1
                    }
                    onRemove={() => remove(index)}
                    // sx={{ borderBottom: "1px solid #ccc"}}
                    sx={{
                      width: isSmallDevice ? "100%" : "100%",
                      //  border : isSmallDevice ?  "1px solid #e0e0e0" : "none",
                      p: isSmallDevice ? 2 : 0,
                    }}
                  />
                </Box>
              ))}

              {/* Add Bank Loan Button */}
              <div className="d-flex justify-content-end mt-3">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => push({ type: "", amount: 0 })}
                >
                  + Add Bank Loan
                </button>
              </div>

              {/* Total Value Display */}
              <div className="mt-4 p-3 bg-light rounded">
                <div className="d-flex align-items-center">
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                      color: "black",
                      mr: 2,
                    }}
                  >
                    Total Value -
                  </Typography>
                  <div
                    style={{
                      padding: "8px 16px",
                      border: "2px solid black",
                      borderRadius: "4px",
                      backgroundColor: "white",
                      fontWeight: "bold",
                      fontSize: "0.875rem",
                      color: "black",
                    }}
                  >
                    ₹
                    {values[libilityList.name]
                      ?.reduce(
                        (total, liability) => total + (liability.amount || 0),
                        0,
                      )
                      ?.toLocaleString() || "0"}
                  </div>
                </div>
              </div>
            </div>
          )}
        </FieldArray>
      </Paper>
    </Box>
  );
};

export default LibilityList;
